/* DRIPCO v15 — lazy quick-add variant data */
(function lazyQuickAddVariants() {
  if (window.__dripcoQuickAddLazy) return;
  window.__dripcoQuickAddLazy = true;

  const cache = new Map();
  const root = () => window.Shopify?.routes?.root || '/';

  function message(popover, text) {
    const el = popover?.querySelector('[data-quick-add-message]');
    if (!el) return;
    el.textContent = text;
    el.hidden = false;
    el.classList.add('quick-add__message--error');
  }

  function setLoading(popover, loading) {
    const loader = popover?.querySelector('[data-quick-add-loading]');
    const options = popover?.querySelector('[data-quick-add-options]');
    if (loader) loader.hidden = !loading;
    if (options) options.hidden = loading;
  }

  function selectedOptions(popover) {
    return Array.from(popover.querySelectorAll('[data-quick-add-option]'))
      .sort((a, b) => parseInt(a.dataset.optionPosition, 10) - parseInt(b.dataset.optionPosition, 10))
      .map((group) => group.querySelector('[data-quick-add-option-input]:checked')?.value || null);
  }

  function findVariant(variants, options) {
    return variants.find((variant) => variant.options.every((value, index) => value === options[index]));
  }

  function updateConfirm(popover) {
    const variantsEl = popover?.querySelector('[data-quick-add-variants]');
    const confirm = popover?.querySelector('[data-quick-add-confirm]');
    if (!variantsEl || !confirm) return;
    let variants;
    try { variants = JSON.parse(variantsEl.textContent || '[]'); } catch (err) { return; }
    const selected = selectedOptions(popover);
    const variant = selected.some((value) => !value) ? null : findVariant(variants, selected);
    confirm.disabled = !variant || !variant.available;
    if (variant?.available) {
      const messageEl = popover.querySelector('[data-quick-add-message]');
      if (messageEl) messageEl.hidden = true;
    }
  }

  async function load(wrap) {
    if (cache.has(wrap.dataset.productHandle)) return cache.get(wrap.dataset.productHandle);
    const handle = wrap.dataset.productHandle;
    if (!handle) throw new Error('Product data unavailable.');
    const promise = fetch(`${root()}products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } })
      .then((res) => { if (!res.ok) throw new Error('Could not load product options.'); return res.json(); })
      .then((product) => {
        cache.set(handle, product.variants || []);
        return product.variants || [];
      })
      .catch((err) => { cache.delete(handle); throw err; });
    cache.set(handle, promise);
    return promise;
  }

  function openPopover(trigger, popover) {
    document.querySelectorAll('[data-quick-add-popover]').forEach((p) => { if (p !== popover) p.hidden = true; });
    document.querySelectorAll('[data-quick-add-trigger][aria-expanded="true"]').forEach((t) => { if (t !== trigger) t.setAttribute('aria-expanded', 'false'); });
    popover.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-quick-add-trigger]');
    if (!trigger || trigger.dataset.singleVariant === 'true') return;
    const wrap = trigger.closest('[data-quick-add]');
    const popover = wrap?.querySelector('[data-quick-add-popover]');
    const variantsEl = popover?.querySelector('[data-quick-add-variants]');
    if (!wrap || !popover || !variantsEl) return;
    if (variantsEl.dataset.loaded === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    openPopover(trigger, popover);
    setLoading(popover, true);
    trigger.classList.add('is-loading');
    trigger.setAttribute('disabled', 'disabled');
    try {
      const variants = await load(wrap);
      variantsEl.textContent = JSON.stringify(variants);
      variantsEl.dataset.loaded = 'true';
      setLoading(popover, false);
      updateConfirm(popover);
    } catch (err) {
      setLoading(popover, false);
      message(popover, err.message || 'Could not load product options.');
    } finally {
      trigger.classList.remove('is-loading');
      trigger.removeAttribute('disabled');
    }
  }, true);

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-quick-add-option-input]');
    if (!input) return;
    updateConfirm(input.closest('[data-quick-add-popover]'));
  });
})();